import util from './util.js';

export default class FetchPoller {
	constructor(fn, delay) {
		this.fn = fn;
		this.delay = delay;
		this.abortController = null;
	}

	start(sync) {
		this.stop();
		this.abortController = new AbortController();
		if(sync) return this.step1();
		this.step();
	}

	stop() {
		if(this.abortController)
			this.abortController.abort();
		this.abortController = null;
	}

	step1() {
		const { signal } = this.abortController;
		return this.fn.call(null, signal)
			.catch(e => { if (!signal.aborted) console.error('FetchPoller stepping step 1', e); })
			.finally(() => { if (!signal.aborted) util.setTimeoutPromise(this.delay, signal).then(() => { if (!signal.aborted) this.step(); }); })
			;
	}

	async step() {
		const { signal } = this.abortController;
		try {
			await this.fn.call(null, signal);
		} catch(e) {
			if (!signal.aborted) console.error('FetchPoller stepping', e);
		} finally {
			if (!signal.aborted) {
				await util.setTimeoutPromise(this.delay, signal);
				if (!signal.aborted) this.step();
			}
		}
	}
}
